export const services = [
    {
        imageSrc: "Implant Dentures.png",
        title: "Implant Dentures",
        description: "Implant dentures, also known as snap-in or snap-on dentures, are a removable prosthesis secured to the jaw with 2-4 dental implants. Enjoy enhanced stability as they can snap into fixed dental implants. Your care team will guide you through selecting the best implant solution to restore your oral health and confidence.",
    },
    {
        imageSrc: "Single Dental Implants.png",
        title: "Single Dental Implants",
        description: "If you only need one tooth replaced, your doctor may recommend a single dental implant. This choice is less invasive and only requires one implant to restore the missing tooth. Your ClearChoice team will work with you to develop a treatment plan that supports your unique dental condition.",
    },
    {
        imageSrc: "Implant Supported Bridge.png",
        title: "Implant Supported Bridge",
        description: "When you need several teeth replaced, your doctor may recommend an implant supported bridge. This supports several missing teeth by attaching the new teeth to fixed dental implants. Implant supported bridges provide more stability than a partial denture, while also preserving the integrity of the jawbone.",
    },
];
